import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import uuid from "uuid";
import linkState from 'linkstate';
import './admin-appointment-services.css';
import LinearProgress from '@material-ui/core/LinearProgress';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import ImageUpload from '../../components/ImageUpload/ImageUpload';
import { Box } from '@material-ui/core';
import { extractImageRef } from '../../utils/imageUtils';

class AdminAppointmentServicesDialog extends Component {

  constructor(props) {
    super(props);

    this.isAddMode = true;

    this.state = {
      service: {
        unikey: '',
        title: '',
        description: '',
        image: 0,
        imageObject: null,
      },
      loading: true,
      snackBar: false,
      originalImageId: null,
    };

    if (Object.keys(props.appointmentServicesData).length >= 1) {
      this.isAddMode = false;
      const { id: originalImageId, object: imageObject } = extractImageRef(props.appointmentServicesData.image);

      this.state.service = {
        ...props.appointmentServicesData,
        image: originalImageId || 0,
        imageObject,
      };
      this.state.originalImageId = originalImageId;
      this.state.loading = false;
    } else {
      this.state.service.unikey = uuid.v4();
      this.state.loading = false;
    }
  }

  handleImageUpload = (uploadData) => {
    if (!uploadData || uploadData.cleared || !uploadData.id) {
      this.setState({
        service: { ...this.state.service, image: 0, imageObject: null },
      });
      return;
    }
    this.setState({
      service: {
        ...this.state.service,
        image: uploadData.id,
        imageObject: uploadData,
      },
    });
  }

  handleImageUploadError = () => {}

  submitDialog()
  {
    var serviceData = { ...this.state.service };
    delete serviceData.imageObject;

    if (!this.isAddMode && serviceData.image === this.state.originalImageId) {
      delete serviceData.image;
    }

    if( serviceData.title === '' || serviceData.description === '' || (this.isAddMode && serviceData.image === 0))
    {
      this.setState({ snackBar: true, });
    }
    else
    {
      this.props.submit(this.isAddMode, serviceData);
    }
  }

  closeSnackBar (event, reason)
  {
    if (reason === 'clickaway') {
      return;
    }

    this.setState({ snackBar: false, });
  }


  render() {
    return (
      <div>
        <DialogTitle id="form-dialog-title">Service { this.isAddMode ? "Erstellen" : "Bearbeiten" }</DialogTitle>
        { this.state.loading ? <LinearProgress color="primary" /> : <span className="loader-span"></span> }
        <DialogContent>
          <div className="ser-line-one">
            <TextField
              autoFocus
              margin="dense"
              id="title"
              label="Titel"
              type="text"
              fullWidth
              variant="outlined"
              value={this.state.service.title}
              onInput={linkState(this, 'service.title')}
            />
          </div>
          <div className="ser-line-one">
            <TextField
              margin="dense"
              id="description"
              multiline
              rows={4}
              label="Beschreibung"
              type="text"
              fullWidth
              variant="outlined"
              value={this.state.service.description}
              onInput={linkState(this, 'service.description')}
            />
          </div>
          <Box style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>Bild</label>
            <ImageUpload
              type="service"
              name="Service"
              label="Bild hierher ziehen oder klicken"
              onUploadComplete={this.handleImageUpload}
              onUploadError={this.handleImageUploadError}
              currentImage={this.state.service.imageObject}
              maxSizeMB={64}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <div className="p-line-end">
            <Button variant="contained" onClick={this.props.close}>
              Abbrechen
            </Button>
            <span></span>
            <Button variant="contained" color="primary" onClick={() => { this.submitDialog() }}>
              Speichern
            </Button>
          </div>
        </DialogActions>
        <Snackbar open={this.state.snackBar} autoHideDuration={6000} onClose={this.closeSnackBar.bind(this)}>
            <MuiAlert elevation={6} variant="filled" onClose={this.closeSnackBar.bind(this)} severity="warning" >
              Alle Felder müssen ausgefüllt sein!
            </MuiAlert>
          </Snackbar>
      </div>
    );
  }
}

export default AdminAppointmentServicesDialog;
